import type ExpressionPickerViewState from './schema/ExpressionPickerViewState';
import type ExpressionStore from './schema/ExpressionStore';
import { ObservableMap } from 'mobx';
import { createStore } from 'satcheljs';
import {
    getOptionsForFeature,
    OwsOptionsFeatureType,
    DiverseEmojisOptions,
} from 'owa-outlook-service-options';

let expressionStoreData: ExpressionStore = {
    expressionPickerViewStates: new ObservableMap<string, ExpressionPickerViewState>(),
    selectedSkinTone: getOptionsForFeature<DiverseEmojisOptions>(
        OwsOptionsFeatureType.DiverseEmojis
    ).diverseEmojisSelectedSkinTone,
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2322 (19,5): Type 'null' is not assignable to type 'boolean'.
    // @ts-expect-error
    useFlexPane: null,
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2322 (23,5): Type 'null' is not assignable to type 'boolean'.
    // @ts-expect-error
    isSxSDisplayed: null,
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2322 (27,5): Type 'null' is not assignable to type 'string'.
    // @ts-expect-error
    primaryExpressionId: null,
};

export let getStore = createStore<ExpressionStore>('expression', expressionStoreData);

var expressionStore = getStore();
export default expressionStore;
